import React from 'react';
import { Wrapper, Title, Button } from './elements';

type Props = {
  readonly className?: string;
  readonly text: string;
  readonly buttonText?: string;
  readonly onClick: () => void;
  readonly isMobile?: boolean;
};

function LoggedActivitiesCard({
  className,
  text,
  buttonText,
  onClick,
  isMobile,
}: Props): React.ReactElement {
  return (
    <Wrapper className={className} noBorder={isMobile}>
      <Title>{text}</Title>
      <Button onClick={onClick}>{buttonText}</Button>
    </Wrapper>
  );
}

export default LoggedActivitiesCard;
